var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChairsideLeftSearch(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "21px",
    height: "22px",
    viewBox: "0 0 21 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon/Search") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Channels",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Chairside-education,-Home",
    transform: "translate(-32.000000, -280.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/Search",
    transform: "translate(32.000000, 280.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.8910448,15.18 L20.6865672,19.9885714 C21.0940299,20.3971429 21.0940299,21.0571429 20.6865672,21.4657143 C20.2791045,21.8742857 19.6208955,21.8742857 19.2134328,21.4657143 L14.3238806,16.5628571 C12.8507463,17.6 11.0328358,18.2285714 9.08955224,18.2285714 C4.07462687,18.2285714 0,14.1428571 0,9.11428571 C0,4.08571429 4.07462687,0 9.08955224,0 C14.1044776,0 18.1791045,4.08571429 18.1791045,9.11428571 C18.1791045,11.44 17.3014925,13.5771429 15.8910448,15.18 Z M9.08955224,16.2485714 C13.0074627,16.2485714 16.2044776,13.0742857 16.2044776,9.11428571 C16.2044776,5.15428571 13.0074627,1.98 9.08955224,1.98 C5.17164179,1.98 1.97462687,5.18571429 1.97462687,9.11428571 C1.97462687,13.0428571 5.17164179,16.2485714 9.08955224,16.2485714 Z",
    id: "Shape"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChairsideLeftSearch);
export default __webpack_public_path__ + "static/media/Chairside-Left-Search.741f3013.svg";
export { ForwardRef as ReactComponent };